import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=0c6a3764&scoped=true";
import script from "./Back.vue?vue&type=script&lang=js";
export * from "./Back.vue?vue&type=script&lang=js";
import style0 from "./Back.vue?vue&type=style&index=0&id=0c6a3764&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "0c6a3764", null);
export default component.exports;